export const headerImg ={
  header_img_url: '/img/header.webp'
}

export const carosel = {
   url1: '/img/1.webp',
   url2: '/img/2.webp',
   url3: '/img/3.webp',
   url4: '/img/4.webp',
   url5: '/img/5.webp',
   url6: '/img/6.webp',
   url7: '/img/7.webp',
   title: 'Adarsh'
}

export const caroselOld = {
   url1: '/img/old/1.webp',
   url2: '/img/old/2.webp',
   url3: '/img/old/3.webp',
   url4: '/img/old/4.webp',
   url5: '/img/old/5.webp',
   url6: '/img/old/6.webp',
   // url7 removed - original 7.png was not tracked in git
}

export const trainingImg = {
  img1 : "/img/book.webp",
  img2 : "/img/pratical.webp",
  img3 : "/img/assignments.webp",
  img4 : "/img/certification.webp",
  img5 : "/img/knowledge.webp"
}

export const msofficeImg = {
  card_url_1 : "/img/cards/ms1.webp",
  card_url_2 : "/img/cards/ms2.webp",
  card_url_3 : "/img/cards/ms3.webp",
  card_url_4 : "/img/cards/ms4.webp"
}

export const dtpImg = {
  card_url_1 : "/img/cards/dtp1.webp",
  card_url_2 : "/img/cards/dtp2.webp",
  card_url_3 : "/img/cards/dtp3.webp",
  card_url_4 : "/img/cards/dtp4.webp"
}

export const cImg = {
  card_url_1 : "/img/cards/c1.webp",
  card_url_2 : "/img/cards/c2.webp",
  card_url_3 : "/img/cards/c3.webp",
  card_url_4 : "/img/cards/c4.webp"
}

export const editingImg = {
  card_url_1 : "/img/cards/ve1.webp",
  card_url_2 : "/img/cards/ve2.webp",
  card_url_3 : "/img/cards/ve3.webp",
  card_url_4 : "/img/cards/ve4.webp"
}

export const tallyimg ={
  card_url_1 : "/img/cards/tally1.webp",
  card_url_2 : "/img/cards/tally2.webp",
  card_url_3 : "/img/cards/tally3.webp",
  card_url_4 : "/img/cards/tally4.webp"
}

export const htmlimg ={
  card_url_1 : "/img/cards/html1.webp",
  card_url_2 : "/img/cards/html2.webp",
  card_url_3 : "/img/cards/html3.webp",
  card_url_4 : "/img/cards/html4.webp"
}

export const footerlogo ={
  logo : "/img/footer-logo.webp"
}

export const ms_gif = {
  gif1 : '/img/gif/office.webp',
  gif2 : '/img/gif/office_static.webp'
}
export const c_gif = {
  gif1 : '/img/gif/c.webp',
  gif2 : '/img/gif/c_static.webp'
}
export const html_gif = {
  gif1 : '/img/gif/html.webp',
  gif2 : '/img/gif/html_static.webp'
}
export const tally_gif = {
  gif1 : '/img/gif/tally.webp',
  gif2 : '/img/gif/tally_static.webp'
}
export const editing_gif = {
  gif1 : '/img/gif/editing.webp',
  gif2 : '/img/gif/editing_static.webp'
}
export const dtp_gif = {
  gif1 : '/img/gif/dtp.webp',
  gif2 : '/img/gif/dtp_static.webp'
}

export const msofficeData = {
  title_1  : "Welcome to Adarsh Computers",
  title_2  : "Training Institution",
  title_3  : "MS OFFICE",
  title_4  : "MS WORD",
  title_5  : "MS EXCEL",
  title_6  : "MS POWERPOINT"
}

export const dtpData = {
  title_1  : "Welcome to Adarsh Computers",
  title_2  : "Training Institution",
  title_3  : "ADOBE PHOTOSHOP",
  title_4  : "PAGEMAKER",
  title_5  : "CORELDRAW",
  title_6  : "",
}

export const cData = {
  title_1  : "Welcome to Adarsh Computers",
  title_2  : "Training Institution",
  title_3  : "C - LANGUAGE",
  title_4  : "Welcome to Adarsh Computers",
  title_5  : "Training Institution",
  title_6  : "C - LANGUAGE",
}

export const htmlData = {
  title_1  : "Welcome to Adarsh Computers",
  title_2  : "Training Institution",
  title_3  : "HYPERTEXT MARKUP LANGUAGE",
  title_4  : "Welcome to Adarsh Computers",
  title_5  : "Training Institution",
  title_6  : "HYPERTEXT MARKUP LANGUAGE",
}

export const tallyData = {
  title_1  : "Welcome to Adarsh Computers",
  title_2  : "Training Institution",
  title_3  : "TALLY",
  title_4  : "Welcome to Adarsh Computers",
  title_5  : "Training Institution",
  title_6  : "TALLY",
}

export const editingData = {
  title_1  : "Welcome to Adarsh Computers",
  title_2  : "Training Institution",
  title_3  : "ADOBE AFTER EFFECTS",
  title_4  : "ADOBE PREMIUM PRO",
  title_5  : "EDIUS",
  title_6  : "",
}

export const aboutImg={
  about_url : '/img/contact_us.webp'
}

export const trainerImg={
  trainer_url: '/img/trainer.webp'
}

export const ms_works = {
  work_url_1: '/img/works/ms/1.webp',
  work_url_2: '/img/works/ms/2.webp',
  work_url_3: '/img/works/ms/3.webp',
  work_url_4: '/img/works/ms/4.webp',
  work_url_5: '/img/works/ms/5.webp',
  work_url_6: '/img/works/ms/6.webp',
  work_url_7: '/img/works/ms/7.webp',
  work_url_8: '/img/works/ms/8.webp',
  work_url_9: '/img/works/ms/9.webp',
  work_url_10: '/img/works/ms/10.webp',
}

export const dtp_works = {
  work_url_1: '/img/works/dtp/1.webp',
  work_url_2: '/img/works/dtp/2.webp',
  work_url_3: '/img/works/dtp/3.webp',
  work_url_4: '/img/works/dtp/4.webp',
  work_url_5: '/img/works/dtp/5.webp',
  work_url_6: '/img/works/dtp/6.webp',
  work_url_7: '/img/works/dtp/7.webp',
  work_url_8: '/img/works/dtp/8.webp',
  work_url_9: '/img/works/dtp/9.webp',
  work_url_10: '/img/works/dtp/10.webp',
}

export const c_works = {
  work_url_1: '/img/works/c/1.webp',
  work_url_2: '/img/works/c/2.webp',
  work_url_3: '/img/works/c/3.webp',
  work_url_4: '/img/works/c/4.webp',
  work_url_5: '/img/works/c/5.webp',
  work_url_6: '/img/works/c/6.webp',
  work_url_7: '/img/works/c/7.webp',
  work_url_8: '/img/works/c/8.webp',
  work_url_9: '/img/works/c/9.webp',
  work_url_10: '/img/works/c/10.webp',
}

export const ve_works = {
  work_url_1: '/img/works/ve/1.webp',
  work_url_2: '/img/works/ve/2.webp',
  work_url_3: '/img/works/ve/3.webp',
  work_url_4: '/img/works/ve/4.webp',
  work_url_5: '/img/works/ve/5.webp',
  work_url_6: '/img/works/ve/6.webp',
  work_url_7: '/img/works/ve/7.webp',
  work_url_8: '/img/works/ve/8.webp',
  work_url_9: '/img/works/ve/9.webp',
  work_url_10: '/img/works/ve/10.webp',
}

export const tally_works = {
  work_url_1: '/img/works/tally/1.webp',
  work_url_2: '/img/works/tally/2.webp',
  work_url_3: '/img/works/tally/3.webp',
  work_url_4: '/img/works/tally/4.webp',
  work_url_5: '/img/works/tally/5.webp',
  work_url_6: '/img/works/tally/6.webp',
  work_url_7: '/img/works/tally/7.webp',
  work_url_8: '/img/works/tally/8.webp',
  work_url_9: '/img/works/tally/9.webp',
  work_url_10: '/img/works/tally/10.webp',
}

export const html_works = {
  work_url_1: '/img/works/html/1.webp',
  work_url_2: '/img/works/html/2.webp',
  work_url_3: '/img/works/html/3.webp',
  work_url_4: '/img/works/html/4.webp',
  work_url_5: '/img/works/html/5.webp',
  work_url_6: '/img/works/html/6.webp',
  work_url_7: '/img/works/html/7.webp',
  work_url_8: '/img/works/html/8.webp',
  work_url_9: '/img/works/html/9.webp',
  work_url_10: '/img/works/html/10.webp',
}

export const registration ={
  register_url: '/img/gif/register.webp'
}

export const about ={
  about_img_url: '/img/gif/about_us.webp'
}

export const contact ={
  contact_img_url: '/img/gif/contact-us.webp'
}

export const training ={
  training_img_url: '/img/gif/training.webp'
}

export const student ={
  student_img_url: '/img/gif/student-works.webp'
}